import { css, keyframes } from '@emotion/core';
/* eslint frontbucket-patterns/no-new-emotion-styled: "warn" */
import styled from '@emotion/styled';

import { colors } from '@atlaskit/theme';
import { N300 } from '@atlaskit/theme/colors';
import { themed } from '@atlaskit/theme/components';
import { token } from '@atlaskit/tokens';

export const Wrapper = styled.div``;

export const MessageWrapper = styled.div`
  margin: 0 0 ${token('space.200', '16px')};
`;

export const NoBrancheSelectorMessage = styled.div`
  margin: 0 0 ${token('space.200', '16px')};
`;

export const FooterButtons = styled.div`
  margin: ${token('space.200', '16px')} 0;
  display: flex;
  justify-content: flex-end;
`;

export const SelectorWrapper = styled.div`
  width: 400px;
  display: inline-block;
  margin-right: ${token('space.100', '8px')};
  margin-bottom: ${token('space.200', '16px')};
`;

export const CustomSelectorWrapper = styled.div`
  width: 400px;
  margin-right: ${token('space.100', '8px')};
  margin-bottom: ${token('space.200', '16px')};
`;

export const Label = styled.label`
  font-size: 12px;
  color: ${themed({
    light: token('color.text.subtlest', colors.N200),
    dark: token('color.text.subtlest', colors.DN300),
  })};
  font-weight: 600;
  display: inline-block;
  margin-bottom: ${token('space.050', '4px')};
  margin-top: 0;
  width: 100%;
`;

export const VariablesWrapper = styled.div`
  margin-top: ${token('space.200', '16px')};

  table {
    border-top: 2px solid ${token('color.border', 'rgb(223, 225, 230)')};
  }

  tr:hover {
    background: ${token('elevation.surface.hovered', colors.N10)};
  }
`;

export const VariablesKeyColumn = styled.td`
  max-width: 200px;
`;

export const VariableDescriptionWrapper = styled.span`
  color: ${token('color.text.subtle', N300)};
  display: inline-flex;
  width: 0;
  min-width: 100%;
`;

export const VariablesDescription = styled.span`
  font-size: 12px;
  display: inline-block;
  vertical-align: middle;
  padding-bottom: ${token('space.050', '4px')};
  overflow-wrap: anywhere;
`;

export const VariableKey = styled.div`
  padding: 0 10px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;

export const Header = styled.span`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

export const Information = styled.div`
  flex: 1 0 auto;
  margin-left: ${token('space.050', '4px')};
  height: 22px;
`;

export const ScheduleGroup = styled.div`
  display: flex;
  align-items: flex-end;
  flex-wrap: wrap;
  margin-bottom: ${token('space.200', '16px')};

  & > div:last-of-type {
    width: 144px;
    margin: 0;
  }

  & > *,
  & > *:first-of-type {
    width: 120px;
    margin-right: ${token('space.100', '8px')};
  }

  & > p {
    font-size: 11px;
    color: ${token('color.text.subtlest', colors.N100)};
    flex-basis: 100%;
    margin: ${token('space.100', '8px')} 0;
  }
`;

export const SchedulesDialogWrapper = styled.div`
  width: 448px;
`;

export const SchedulesWrapper = styled.div`
  text-align: left;

  header {
    display: flex;
    margin-bottom: ${token('space.150', '12px')};
  }
`;

export const SchedulesTitle = styled.h3`
  line-height: 32px;
  color: inherit;
  flex: 1 0 auto;
`;

export const SchedulesTable = styled.table`
  tbody {
    border-bottom-width: 0;
  }

  th {
    color: ${token('color.text.subtlest', colors.N100)};
    font-weight: 500;
    font-size: 12px;
  }

  td:last-child,
  th:last-child {
    padding-left: 0;
  }
`;

export const SchedulesList = styled.div`
  max-height: 200px;
  overflow: scroll;
`;

const highlightAnimation = keyframes({
  '0%': {
    background: token('color.background.input', colors.N20),
  },
  '100%': {
    background: 'none',
  },
});

export const SchedulesRow = styled.tr`
  animation: ${(props: any) =>
    !props.isNew
      ? // eslint-disable-next-line @atlaskit/design-system/no-css-tagged-template-expression
        css`
          ${highlightAnimation} 1.5s ease-in
        `
      : 'none'};
  ${(props: any) =>
    !props.isEnabled
      ? `color: ${token('color.text.subtlest', colors.N100)}`
      : ''};

  td {
    height: 32px;
    font-size: 12px;

    &:nth-child(1) {
      width: 44px;
    }

    &:nth-child(2) div {
      width: 80px;
    }

    &:nth-child(3) div {
      width: 90px;
    }

    &:nth-child(4) > div {
      width: 138px;
    }

    &:nth-child(5) {
      width: 40px;
    }

    &:nth-child(2) div,
    &:nth-child(3) div,
    &:nth-child(4) div {
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }
  }

  button {
    visibility: hidden;
  }

  &:hover {
    background: ${token('color.background.neutral.hovered', colors.N20)};

    button {
      visibility: visible;
    }
  }
`;

export const SchedulesHeadRow = styled.tr`
  th {
    &:nth-child(1) {
      width: 44px;
    }

    &:nth-child(2) {
      width: 80px;
    }

    &:nth-child(3) {
      width: 90px;
    }

    &:nth-child(4) {
      width: 138px;
    }
  }
`;

export const SchedulesDateWrapper = styled.div`
  display: flex;
  justify-content: space-between;
`;

export const SchedulesWarning = styled.div`
  color: ${token('color.text.danger', colors.R400)};
`;

export const SchedulesEmpty = styled.td`
  text-align: center;

  svg {
    margin-top: ${token('space.100', '8px')};
    position: relative;
  }
`;

export const CreateScheduleButtonWrapper = styled.div`
  position: relative;
`;

export const CreateScheduleButtonOverlay = styled.div`
  z-index: 1;
  width: 100%;
  height: 100%;
  position: absolute;
  cursor: not-allowed;
`;
